import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';

@Component({
    selector: 'app-popovers-back',
    styleUrls: ['app-popovers-back.component.scss'],
    template: `
        <button type="button" (click)="navigateBack()">
            <span>
                <i></i>
                <span i18n="@@PopoversBackClose">Close</span>
            </span>
        </button>
    `
})
export class PopoversBackComponent {
    @Input() preventDefault: boolean;
    constructor(
        private location: Location
    ) {}

    navigateBack() {
        // this.location.back();
    }
}
